import Plyr from '../thirdparty/plyr.polyfilled.js';

if (document.querySelectorAll('.js-player')) {
	const players = Array.from(document.querySelectorAll('.js-player')).map(
		(player) =>
			new Plyr(player, {
				settings: ['speed'],
				tooltips: { controls: true, seek: true },
			})
	);
}
